import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

if (process.env.REACT_APP_DDRUM_CLIENT_TOKEN) {
  const datadogCommonConfig = {
    clientToken: process.env.REACT_APP_DDRUM_CLIENT_TOKEN,
    env: process.env.REACT_APP_DEFAULT_ENV,
    sampleRate: 100,
    service: process.env.REACT_APP_APP_NAME!,
    silentMultipleInit: true,
    site: 'datadoghq.com',
    trackSessionAcrossSubdomains: true,
    trackInteractions: true,
    useCrossSiteSessionCookie: true,
    version: process.env.REACT_APP_VERSION,
  };

  /**
   * Datadog browser logs configuration
   * {@link https://docs.datadoghq.com/logs/log_collection/javascript/#configuration}
   */
  datadogLogs.init({
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error'],
    ...datadogCommonConfig,
  });

  /**
   * Datadog browser RUM configuration
   * {@link https://docs.datadoghq.com/real_user_monitoring/browser/#configuration}
   */
  datadogRum.init({
    applicationId: process.env.REACT_APP_DDRUM_APP_ID || '',
    ...datadogCommonConfig,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
